import { Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { theme } from '../../utils/theme';
import { RootineImage } from '../../atoms/RootineImage';
import { RootineIconAndText } from '../../atoms/RootineIconAndText';
import { ReactComponent as XCircleIcon } from '../../images/x-circle.svg';
import { ReactComponent as CheckCircleIcon } from '../../images/check-circle.svg';
import RootineButton from '../../atoms/RootineButton';
import { CHECKOUT_URLS } from '../../config';

interface IconTextItem {
  title: string;
  description?: string;
}

const genericItems: IconTextItem[] = [
  {
    title: 'Not personalized for you unique needs',
  },
  {
    title: 'Cabinet full of bottles',
  },
  {
    title: 'NO precision dosaging',
  },
  {
    title: 'NO guidance',
  },
  {
    title: 'Synthetic forms of vitamins',
  },
  {
    title: 'May contain additives and fillers',
  },
];

const smartItems: IconTextItem[] = [
  {
    title: 'Personalized based on lab testing & lifestyle assessment',
  },
  {
    title: 'Travel-ready packs',
  },
  {
    title: 'Optimized for bioavailability',
  },
  {
    title: 'Never made with fillers or additives',
  },
  {
    title: 'Made with organic nutrients',
  },
  {
    title: '1:1 call with Nutritionist available',
  },
];

export const ProductComparisonSection = (): JSX.Element => {
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      item
      sx={{
        py: 12,
        px: { xs: 3, md: 10, lg: 14 },
      }}
    >
      <Grid container flexDirection="column" wrap="nowrap">
        <Typography fontSize={16} sx={{ textTransform: 'uppercase' }}>
          Attention
        </Typography>
        <Typography variant="medium" fontSize={40} sx={{ mt: 2, mb: 6 }}>
          Not all Multivitamins are created equally
        </Typography>

        <Grid item>
          <Grid
            container
            flexDirection={isTablet ? 'column' : 'row'}
            alignItems="flex-start"
            justifyContent={isTablet ? 'center' : 'space-between'}
          >
            <Grid item xs={12} md={6} lg={5}>
              <RootineImage
                src="/images/regular_multi.jpeg"
                size={isMobile ? undefined : isTablet ? 'xl' : 'lg'}
              />
              <Grid container flexDirection="column">
                <Typography
                  variant="medium"
                  fontSize={24}
                  sx={{ mt: 4, mb: 5 }}
                >
                  Generic Multivitamin
                </Typography>

                {genericItems.map((item: IconTextItem, index: number) => (
                  <Grid sx={{ mb: 1.5 }} key={`${index}-${item}`}>
                    <RootineIconAndText
                      icon={<XCircleIcon />}
                      title={item.title}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={6} lg={5}>
              <RootineImage
                src="/images/smart_multi.png"
                size={isMobile ? undefined : isTablet ? 'xl' : 'lg'}
              />
              <Grid container flexDirection="column">
                <Typography
                  variant="medium"
                  fontSize={24}
                  sx={{ mt: 4, mb: 5 }}
                >
                  Smart Multivitamin
                </Typography>

                {smartItems.map((item: IconTextItem, index: number) => (
                  <Grid sx={{ mb: 1.5 }} key={`${index}-${item}`}>
                    <RootineIconAndText
                      icon={<CheckCircleIcon />}
                      title={item.title}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <RootineButton
            url={CHECKOUT_URLS.vitamins.link}
            label="Personalize my Smart Mulitvitamin"
            ariaLabel="Buy smart multivitamin now"
            variation="primary"
            size="large"
            sx={{ mt: 11 }}
            as="a"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
